/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationStatisticsModel } from '../../models/organization-statistics-model';

export interface IntegrationOrganizationStatisticsSystemIdentifierIdOrganizationIdGet$Params {

/**
 * The unique identifier of the system
 */
  systemIdentifierId: string;

/**
 * The unique identifier of the organization
 */
  organizationId: string;

/**
 * The start date for the statistics period
 */
  fromDate?: string;

/**
 * The end date for the statistics period
 */
  toDate?: string;
}

export function integrationOrganizationStatisticsSystemIdentifierIdOrganizationIdGet(http: HttpClient, rootUrl: string, params: IntegrationOrganizationStatisticsSystemIdentifierIdOrganizationIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<OrganizationStatisticsModel>>> {
  const rb = new RequestBuilder(rootUrl, integrationOrganizationStatisticsSystemIdentifierIdOrganizationIdGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.path('organizationId', params.organizationId, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<OrganizationStatisticsModel>>;
    })
  );
}

integrationOrganizationStatisticsSystemIdentifierIdOrganizationIdGet.PATH = '/Integration/OrganizationStatistics/{systemIdentifierId}/{organizationId}';
